import { Combobox, ComboboxProps, useComboboxFilter } from "@fluentui/react-components";
import React from "react";
import { Option } from "../modules/Categories/data/Option";

type BaseOptionComboboxProps = {
    id: string,
    data: Option[] | undefined,
    defaultValue: string,
    disabled: boolean,
    onChange: (value: number) => void;
};

export default function BaseOptionCombobox({ id, data, defaultValue, disabled, onChange }: BaseOptionComboboxProps) {
    const [query, setQuery] = React.useState<string>("");

    const onOptionSelect: ComboboxProps["onOptionSelect"] = (e, data) => {
        onChange(parseInt(data.optionValue ?? "0", 10));
        setQuery(data.optionText ?? "");
    };

    const optionData = React.useMemo(() => {
        return data?.map((option) => {
            return {
                children: option.name,
                value: option.id.toString(),
                text: option.name,
            };
        }) ?? [];
    }, [data]);

    const comboboxItems = useComboboxFilter(query, optionData, {
        noOptionsMessage: "No option match your search.",
        optionToText: (option) => option.text,
    });

    React.useEffect(() => {
        setQuery(data?.find((option) => option.id.toString() === defaultValue)?.name ?? "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Combobox
            id={id}
            defaultValue={defaultValue}
            defaultSelectedOptions={[defaultValue]}
            inlinePopup={true}
            value={query}
            onOptionSelect={onOptionSelect}
            onChange={(ev) => setQuery(ev.target.value)}
            clearable={true}
            disabled={disabled}
            positioning={{
                fallbackPositions: ["below", "above"],
            }}
        >
            {comboboxItems}
        </Combobox>
    );
}